import React, { useState, useEffect } from "react";
import { Button, FormGroup, Label, Row, Col } from "reactstrap";
import { InputTextarea } from "primereact/inputtextarea";

import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import LoadingScreen from "react-loading-screen";
import logo from "../../../../../assets/img/logo/logo_aig_login-2.png";

import CrearCompromisoLayout from "../../../components/CrearCompromisoLayout";
import MessageDialog from "../../../../../components/Compras/MessageDialog";

import "./InformacionCompromiso.css";

import {
    setDatosNuevoCompromiso,
    guardarCompromiso,
    configuracionCompromisos
} from "../../../redux/aCompromisos";

import {
    selectNuevoCompromiso,
    selectGuardarCompromisoLoading,
} from "../../../redux/selectors";

const InformacionCompromiso = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const nuevoCompromiso = useSelector(selectNuevoCompromiso);
    const guardarCompromisoLoading = useSelector(selectGuardarCompromisoLoading);

    const [instrucciones, setInstrucciones] = useState(nuevoCompromiso.instrucciones || "");
    const [maxLength, setMaxLength] = useState(2000);
    const [mostrarMensaje, setMostrarMensaje] = useState(false);
    const [mensaje, setMensaje] = useState("");
    const [esExito, setEsExito] = useState(false);

    useEffect(() => {
        const cargarConfiguracion = async () => {
            try {
                const response = await dispatch(configuracionCompromisos());
                const maxLength = Number(response && response.data && response.data.maxLength);
                setMaxLength(maxLength);
            } catch (error) {
                console.error(
                    "Error cargando configuración de compromisos",
                    error
                );
            }
        };

        cargarConfiguracion();
    }, [dispatch]);

    const guardarDatosRedux = () => {

        dispatch(
            setDatosNuevoCompromiso({
                instrucciones,
            })
        );
    };


    const handleAnterior = () => {
        guardarDatosRedux();
        history.push("/compromisos/crear/datos-negocio");
    };

    const handleCancelar = () => {
        history.push("/compromisos/listado");
    };



    const handleSiguiente = async () => {
        try {

            guardarDatosRedux();

            const datosGuardar = {
                instrucciones: instrucciones,
                pantallaFinal: true,
                pasoActual: 4
            };
            const respuesta = await dispatch(
                guardarCompromiso(
                    datosGuardar
                )
            );

            if (!respuesta.success) {
                if (
                    respuesta.payload.error_code ==="DUPLICATE_COMMITMENT"
                ) {
                    console.log("AQUI2");
                    setMensaje(
                        respuesta.payload.message ||
                        "Ya existe un compromiso con el mismo cliente y ramos"
                    );

                    setEsExito(false);
                    setMostrarMensaje(true);
                }

                return;
            }

            setMensaje(
                "El compromiso ha sido creado correctamente y fue enviado a distribución para su revisión."
            );

            setEsExito(true);
            setMostrarMensaje(true);

        } catch (error) {
            console.error(
                "ERROR HANDLE SIGUIENTE:",
                error
            );
        }
    };

    return (
        <LoadingScreen
            loading={guardarCompromisoLoading}
            bgColor="#f1f1f1"
            spinnerColor="#001871"
            textColor="#676767"
            logoSrc={logo}
            text="Creando compromiso..."
        >
            <CrearCompromisoLayout
                activeStep={4}
                tituloPaso="Instrucciones Adicionales"
            >

                <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>


                        <FormGroup className="instrucciones-form-group">

                            <div className="instrucciones-descripcion">
                                Por favor escribe cualquier instrucción que AIG deba tener en cuenta
                                para emitir una cotización para esta oportunidad de negocio.
                            </div>

                            <InputTextarea
                                value={instrucciones}
                                onChange={(e) => setInstrucciones(e.target.value)}
                                className="w-100 instrucciones-textarea"
                                maxLength={maxLength}
                                placeholder="Escriba..."
                            />

                            <small className="instrucciones-contador">
                                {instrucciones.length}/{maxLength} caracteres
                            </small>

                        </FormGroup>
                    </Col>
                </Row>



                <div className="compromiso-actions">

                    <Button
                        className="compromiso-button compromiso-button-regresar"
                        onClick={handleAnterior}
                    >
                        <span aria-hidden="true" className="compromiso-button-icon">‹</span>
                        Regresar
                    </Button>

                    <Button className="compromiso-button compromiso-button-cancelar" onClick={handleCancelar}>
                        Cancelar
                    </Button>

                    <Button
                        className="compromiso-button compromiso-button-consultar"
                        //disabled={!formularioValido()}
                        onClick={handleSiguiente}
                    >
                        Crear compromiso
                    </Button>


                </div>
            </CrearCompromisoLayout>
            <MessageDialog
                isOpen={mostrarMensaje}
                message={mensaje}
                onConfirm={() => {

                    setMostrarMensaje(false);

                    if (esExito) {
                        history.push(
                            "/compromisos/listado"
                        );
                    }
                }}
            />
        </LoadingScreen>

    );
};

export default InformacionCompromiso;